import vote from './../../fetch/vote.js'
import * as types from './../types.js'

const state = {
    candidateListMsg: {
        data: [],
        msg: {}
    },
    candidateMsg: {},
    voteMsg: {
        error_code: 0,
        msg: ''
    }
}

const actions = {
    getCandidateListApi({
        commit
    }) {
        return new Promise((resolve, reject) => {
            vote.newsListApi().then((res) => {
                commit(types.GET_CANDIDATE_LIST, res);
                resolve()
            }).catch(() => {
                reject()
            })
        })
    },
    getCandidateApi({
        commit
    }, id) {
        return new Promise((resolve, reject) => {
            vote.newApi(id).then((res) => {
                commit(types.GET_CANDIDATE, res);
                resolve()
            }).catch(() => {
                reject()
            })
        })
    },
    voteApi({
        commit
    }, id) {
        let voteId = id;
        return new Promise((resolve, reject) => {
            vote.voteApi(voteId).then((res) => {
                commit(types.VOTE, res);
                resolve();
            }).catch(() => {
                reject()
            })
        })
    }
}

const getters = {
    candidateListMsg: state => state.candidateListMsg,
    candidateMsg: state => state.candidateMsg,
    voteMsg: state => state.voteMsg
}

const mutations = {
    [types.GET_CANDIDATE_LIST](state, res) {
        state.candidateListMsg = {
            ...state.candidateListMsg,
            data: res.data.data
        };
    },
    [types.GET_CANDIDATE](state, res) {
        state.candidateMsg = res.data.data;
    },
    [types.VOTE](state, res) {
        state.voteMsg = {
            error_code: res.data.error_code,
            msg: res.data.msg
        };
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}